<div class="table-wrap">
  <div class="dash-welcome">{{ getGreeting() }}, {{ stateService.getUserFirstName() }}</div>
  <div class="dash-welcome-sub">Summary of your activity in AdGate</div>

  <!-- Stats Cards Grid -->
  <div class="dashboard-grid">
    <div class="dash-card clickable">
      <div class="dash-card-icon pending">
        <i class="fa-solid fa-clock"></i>
      </div>
      <div class="dash-card-value">{{ stats.pending }}</div>
      <div class="dash-card-label">Pending</div>
      <div class="dash-card-action" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_LINEAR)">
        <i class="fa-solid fa-arrow-right"></i> View Pending TV/Radio
      </div>
      <div class="dash-card-action" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_STREAMING)">
        <i class="fa-solid fa-arrow-right"></i> View Pending Streaming
      </div>
      <div class="dash-card-action" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_PRODUCTION)">
        <i class="fa-solid fa-arrow-right"></i> View Pending Production
      </div>
    </div>

    <div class="dash-card clickable">
      <div class="dash-card-icon rejected">
        <i class="fa-solid fa-xmark"></i>
      </div>
      <div class="dash-card-value">{{ stats.rejected }}</div>
      <div class="dash-card-label">Rejected</div>
      <div class="dash-card-action" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_LINEAR)">
        <i class="fa-solid fa-arrow-right"></i> View Pending TV/Radio
      </div>
      <div class="dash-card-action" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_STREAMING)">
        <i class="fa-solid fa-arrow-right"></i> View Pending Streaming
      </div>
      <div class="dash-card-action" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_PRODUCTION)">
        <i class="fa-solid fa-arrow-right"></i> View Pending Production
      </div>
    </div>

    <div class="dash-card clickable">
      <div class="dash-card-icon processing">
        <i class="fa-solid fa-spinner"></i>
      </div>
      <div class="dash-card-value">{{ stats.review }}</div>
      <div class="dash-card-label">Review</div>
      <div class="dash-card-action" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_LINEAR)">
        <i class="fa-solid fa-arrow-right"></i> View Pending TV/Radio
      </div>
      <div class="dash-card-action" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_STREAMING)">
        <i class="fa-solid fa-arrow-right"></i> View Pending Streaming
      </div>
      <div class="dash-card-action" (click)="this.moduleActivationService.activateModule(AdGateConstants.MODULE_PRODUCTION)">
        <i class="fa-solid fa-arrow-right"></i> View Pending Production
      </div>
    </div>

    <div class="dash-card clickable">
      <div class="dash-card-icon approved">
        <i class="fa-solid fa-check"></i>
      </div>
      <div class="dash-card-value">{{ stats.approved }}</div>
      <div class="dash-card-label">Approved</div>
      <!-- <div class="dash-card-action">
        <i class="fa-solid fa-arrow-right"></i> View Approved
      </div> -->
    </div>
  </div>

  <!-- Two Column Layout -->
  <div class="dashboard-content-grid">
    <!-- Urgent Items -->
    <div class="data-card">
      <div class="card-header">
        <div class="dash-section-title">
          <i class="fa-solid fa-bell"></i> Requires Attention
        </div>
      </div>
      <div class="dash-urgent-list">
        @if (urgentItems.length > 0) {
          @for (item of urgentItems; track item) {
            <div class="dash-urgent-item" (click)="navigateToPending(item.objectType)">
              <span class="badge" [ngClass]="{
                'badge-new': item.status.id == -1,
                'badge-pending': item.status.id == -2,
                'badge-processing': item.status.id == 63,
                'badge-rejected': item.status.id == 7 || item.status.id == 44,
                'badge-reload': item.status.id == 5 || item.status.id == 45,
                'badge-approved': item.status.id == -6
                }">
                <span class="badge-dot"></span>
                {{item.status | objectdesc}}
              </span>
              <span class="item-brand">{{ item.brand }}</span>
              <span class="text-sm text-muted">{{ item.title }}</span>
              @if( item.status.id !== 7 && item.status.id !== 44 ) {
                @if (getTimeFlag(item.hoursAgo); as flag) {
                  <span class="time-flag" [ngClass]="'time-flag-' + flag">
                    <i class="fa-solid" [ngClass]="flag === '48h' ? 'fa-exclamation' : 'fa-clock'"></i>
                    +{{ flag }}
                  </span>
                }
              }
            </div>
          }
        } @else {
          <div class="empty-state-small">
            No urgent materials
          </div>
        }
      </div>
    </div>

    <!-- Recent Activity -->
    <div class="data-card">
      <div class="card-header">
        <div class="dash-section-title">
          <i class="fa-solid fa-clock-rotate-left"></i> Recent Activity
        </div>
      </div>
      <div class="dash-activity-list">
        @if (activityLog.length > 0) {
          @for (e of activityLog; track e) {
            <div class="dash-activity-item">
              <div class="dash-activity-dot" [style.background]="getDotColor(e.objectType)"></div>
              <span class="dash-activity-msg">{{ e.event }}</span>
              <span class="dash-activity-time">{{ getElapsedTime(e.hoursAgo) }}</span>
            </div>
          }
        } @else {
          <div class="empty-state-small">
            No recent activity
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Favorites Section (if any) -->
  <!-- @if (favorites.length > 0) {
    <div class="data-card favorites-card">
      <div class="card-header">
        <div class="dash-section-title">
          <i class="fa-solid fa-star" style="color: var(--yellow-dot)"></i> Favorites
        </div>
      </div>
      <div class="dash-activity-list">
        @for (fav of favorites; track fav.id) {
          <div class="dash-activity-item" (click)="navigateToPending()">
            <i class="fa-solid fa-star" style="color: var(--yellow-dot); font-size: 12px"></i>
            <span class="dash-activity-msg">
              <strong>{{ fav.brand }}</strong> – {{ fav.title }}
            </span>
            <span class="badge" [ngClass]="'badge-' + fav.status">
              <span class="badge-dot"></span>
              {{ fav.status === 'pending' ? 'Pending' :
                 fav.status === 'rejected' ? 'Rejected' :
                 fav.status === 'processing' ? 'Review' :
                 'Approved' }}
            </span>
          </div>
        }
      </div>
    </div>
  } -->
</div>
